import {
  DynamicField,
  DynamicForm,
  FieldVariant,
  SwitchFieldProps,
  TextareaFieldProps,
  TextFieldProps,
} from '@/components/form-builder/form-builder.types';
import { FundingSourceRepository } from '@/store/funding-source-state/funding-source-state.repository';
import { ToggleSwitchChangeEvent } from 'primeng/toggleswitch';

interface getFundingSourceCreateFormObjectProps {
  store: FundingSourceRepository;
}

export const getFundingSourceCreateFormObject = ({ store }: getFundingSourceCreateFormObjectProps): DynamicForm => {
  const codeField: DynamicField<TextFieldProps> = {
    label: 'fundingSources.form.code',
    variant: FieldVariant.TEXT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'code'),
    props: {
      value: store.getNestedObservable<string>('createDto', 'code'),
      onChange: (value: string) => {
        store.setNested('createDto', 'code', value);
        store.setNested('errors', 'code', '');
      },
    },
  };

  const descriptionField: DynamicField<TextareaFieldProps> = {
    label: 'fundingSources.form.description',
    variant: FieldVariant.TEXTAREA,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'description'),
    props: {
      value: store.getNestedObservable<string>('createDto', 'description'),
      onChange: (value: string) => {
        store.setNested('createDto', 'description', value);
        store.setNested('errors', 'description', '');
      },
      cols: 40,
      rows: 10,
    },
  };

  const funderField: DynamicField<SwitchFieldProps> = {
    label: 'fundingSources.form.funder',
    variant: FieldVariant.SWITCH,
    error: store.getNestedObservable<string>('errors', 'bailleurDeFonds'),
    props: {
      checked: store.getNestedObservable<boolean>('createDto', 'bailleurDeFonds'),
      onChange: (value: ToggleSwitchChangeEvent) => {
        store.setNested('createDto', 'bailleurDeFonds', value.checked, false);
        store.setNested('errors', 'bailleurDeFonds', '');
      },
    },
  };

  return {
    title: 'fundingSources.singular',
    description: 'fundingSources.singular',
    orientation: 'horizontal',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [codeField],
          },
          {
            fields: [descriptionField],
          },
          {
            fields: [funderField],
          },
        ],
      },
    ],
  };
};
